import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * 本文中のセクション見出し（WorkflowSection ベース）。
 * params: title（必須）、number（ウォーターマーク）、subNumber（サブ見出し帯）、anchor（アンカー）
 * children: 配下ブロック
 */
export const Section: React.FC<KnzComponentProps> = ({ node, renderChildren }) => {
  const title = (node.params.title as string) ?? '';
  const numberStr = node.params.number as string | undefined;
  const subNumber = node.params.subNumber as string | undefined;
  const anchor = node.params.anchor as string | undefined;
  const isSub = subNumber != null && subNumber !== '';

  return (
    <Box id={anchor}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          height: isSub ? 30 : 36,
          mb: 2,
          overflow: 'hidden',
          background: isSub
            ? 'linear-gradient(to right, #1b5e20, #1b5e2000)'
            : 'linear-gradient(to right, #1a3a5c, #1a3a5c00)',
          clipPath: 'polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%)',
          pl: isSub ? 4.5 : 5,
          pr: 4,
          borderRadius: '4px 0 0 4px',
        }}
      >
        {(numberStr != null || isSub) && (
          <Typography
            sx={{
              position: 'absolute',
              left: 4,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: isSub ? 22 : 48,
              fontWeight: 900,
              lineHeight: 1,
              color: isSub ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.15)',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            {isSub ? subNumber : numberStr}
          </Typography>
        )}
        <Typography
          variant={isSub ? 'body2' : 'subtitle2'}
          fontWeight={isSub ? 600 : 700}
          sx={{ color: '#fff', letterSpacing: 0.3, whiteSpace: 'nowrap', position: 'relative' }}
        >
          {title}
        </Typography>
      </Box>
      <Stack spacing={1.5}>{renderChildren(node.children)}</Stack>
    </Box>
  );
};

export default Section;
